import styled from 'styled-components';
import { device } from '../../../../ui-components/breakpoints';

import PlayLinkContainer from '../../../Link/PlayLinkContainer.jsx';
import sprite from 'public/static/images/sprite.png';
import sprite2x from 'public/static/images/sprite-2x.png';

export const PlayLogo = styled(PlayLinkContainer)`
    background-image: url(${sprite});
    background-position: 0 -53px;
    width: 80px;
    height: 34px;
    display: block;
    margin: 10px auto 0;

    &:focus,
    &:visited {
        outline: 0;
    }

    @media ${device.MinResolution2x} {
        background-image: url(${sprite2x});
        background-size: 120px 117px;
    }

    @media ${device.GteSmall} {
        float: left;
        margin-right: 10px;
        margin-bottom: 0;
        margin-top: 0;
        width: 81px;
    }

    @media ${device.GteMedium} {
        background-image: url(${sprite});
        background-position: 0 -53px;
        width: 80px;
        height: 34px;

        @media ${device.MinResolution2x} {
            background-image: url(${sprite2x});
            background-size: 120px 117px;
        }
    }

    @media ${device.GteLarge} {
        margin-right: 40px;
    }
`;
